import http from 'conversations-http/clients/http';
export function fetchVisitorService({
  vid
}) {
  return http.get(`messages/v2/visitor/${vid}`);
}